import React from "react";
import { View, StyleSheet } from "react-native";
import AdminLayout from "../../layouts/AdminLayout.web";
import { SafetySupportScreen } from "../../components/adminDashboard/SafetySupport/SafetySupportScreen";

function SafetySupportView() {
  return (
    <AdminLayout withPadding={false}>
      <View style={styles.pageBackground}>
        <SafetySupportScreen />
      </View>
    </AdminLayout>
  );
}

const styles = StyleSheet.create({
  pageBackground: {
    flex: 1,
    backgroundColor: "#F2F4F7",
    // @ts-expect-error - works on web
    minHeight: "100vh",
  },
});

export default SafetySupportView;
